<template>
    <span>
        <div class="row-fluid">
            <div class="body">
                <div class="page-header"></div>
                <div class="row">
                    <div class="col-md-4">
                        <div class="card">
                            <div class="card-header">Reports</div>
                            <div class="card-body">
                                <div class="list-group">
                                    <router-link
                                        :class="{ active: is_active(report) }"
                                        :key="report.name"
                                        :to="{
                                            name: 'reports',
                                            params: { reportName: report.name },
                                        }"
                                        class="list-group-item d-flex justify-content-between align-items-center"
                                        v-for="report in reports_list"
                                    >
                                        <h4 class="list-group-item-heading">
                                            {{ report.title }}
                                        </h4>
                                        <p class="list-group-item-text">
                                            {{ report.description }}
                                        </p>

                                        <span class="badge"
                                            ><menu-right-outline-icon
                                        /></span>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header">Parameters</div>
                            <div class="card-body">
                                <div
                                    class="alert alert-info"
                                    v-if="current_report == null"
                                >
                                    Please select a report on the Left to
                                    generate
                                </div>
                                <div class="" v-if="current_report">
                                    <div class="alert alert-war" v-if="working">
                                        Loading Report Details
                                    </div>
                                    <div class="lead">
                                        {{ current_report.description }}
                                    </div>
                                    <div v-if="!working">
                                        <div v-if="current_report != null">
                                            <h1 class="title is-1">
                                                {{
                                                    current_report.props
                                                        .title ||
                                                    $route.params.reportName
                                                }}
                                            </h1>
                                            {{
                                                current_report.props.description
                                            }}

                                            <b-form-group
                                                :key="param.name"
                                                :label="param.promptText"
                                                label-cols="4"
                                                label-cols-lg="3"
                                                v-for="param in current_report.params"
                                                v-if="!param.isHidden"
                                            >
                                                <span v-if="formState.debug"
                                                    >{{ param.controlType }},
                                                    {{ param.type }}</span
                                                >

                                                <div
                                                    v-if="
                                                        param.controlType == 1
                                                    "
                                                >
                                                    <div
                                                        v-if="
                                                            param.paramType !=
                                                            'multi-value'
                                                        "
                                                    >
                                                        <b-select
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        >
                                                            <option
                                                                :key="
                                                                    option.value
                                                                "
                                                                :value="
                                                                    option.value
                                                                "
                                                                v-for="option in param.listEntries"
                                                            >
                                                                {{
                                                                    option.label
                                                                }}
                                                            </option>
                                                        </b-select>
                                                    </div>
                                                    <div
                                                        style="
                                                            overflow-x: scroll;
                                                            height: 400px;
                                                        "
                                                        v-if="
                                                            param.paramType ==
                                                            'multi-value'
                                                        "
                                                    >
                                                        <div
                                                            :key="o.value"
                                                            class="form-check"
                                                            v-for="o in param.listEntries"
                                                        >
                                                            <label>
                                                                <input
                                                                    :name="
                                                                        param.name
                                                                    "
                                                                    :value="
                                                                        o.value
                                                                    "
                                                                    class="form-control"
                                                                    type="checkbox"
                                                                />
                                                                {{ o.label }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="
                                                        param.controlType == 3
                                                    "
                                                >
                                                    <b-checkbox
                                                        :false-value="0"
                                                        :label="
                                                            param.promptText
                                                        "
                                                        :placeholder="
                                                            param.name
                                                        "
                                                        :true-value="1"
                                                        v-model="
                                                            params_values[
                                                                param.name
                                                            ]
                                                        "
                                                    ></b-checkbox>
                                                </div>
                                                <div
                                                    v-if="
                                                        param.controlType == 0
                                                    "
                                                >
                                                    <div
                                                        v-if="
                                                            param.type == 1 ||
                                                            param.type == 0 ||
                                                            param.type == -1
                                                        "
                                                    >
                                                        <b-input
                                                            :label="
                                                                param.promptText
                                                            "
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>

                                                    <div v-if="param.type == 7">
                                                        <o-date-time
                                                            :form-state="
                                                                formState
                                                            "
                                                            :name="param.name"
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            :server-errors="se"
                                                            hide-time
                                                            nolabel
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        >
                                                        </o-date-time>
                                                    </div>

                                                    <div v-if="param.type == 4">
                                                        <o-date-time
                                                            :form-state="
                                                                formState
                                                            "
                                                            :name="param.name"
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            :server-errors="se"
                                                            nolabel
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>

                                                    <div v-if="param.type == 8">
                                                        <input
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            class="form-control"
                                                            type="text"
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>

                                                    <div v-if="param.type == 3">
                                                        <input
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            class="form-control"
                                                            step="0.01"
                                                            type="number"
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>

                                                    <div v-if="param.type == 5">
                                                        <checkbox
                                                            :false-value="0"
                                                            :label="
                                                                param.promptText
                                                            "
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :true-value="1"
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        ></checkbox>
                                                    </div>

                                                    <div v-if="param.type == 6">
                                                        <input
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            class="form-control"
                                                            step="1"
                                                            type="number"
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>

                                                    <div v-if="param.type == 2">
                                                        <input
                                                            :placeholder="
                                                                param.name
                                                            "
                                                            :required="
                                                                !param.allowBlank
                                                            "
                                                            class="form-control"
                                                            step="0.000001"
                                                            type="number"
                                                            v-model="
                                                                params_values[
                                                                    param.name
                                                                ]
                                                            "
                                                        />
                                                    </div>
                                                </div>

                                                <div class="help-block">
                                                    {{ param.helpText }}
                                                </div>
                                            </b-form-group>
                                        </div>
                                        <b-form-group
                                            label="Format"
                                            label-cols="4"
                                            label-cols-lg="3"
                                        >
                                            <b-form-select
                                                :options="formats"
                                                placeholder="Format"
                                                required
                                                v-model="params_values._format"
                                            />
                                        </b-form-group>

                                        <form
                                            :action="downloadURL"
                                            method="post"
                                            ref="downloadForm"
                                            target="_downloadReport"
                                        >
                                            <input
                                                name="__timezone"
                                                type="hidden"
                                                value="Australia/Melbourne"
                                            />

                                            <input
                                                :value="_filename"
                                                name="_filename"
                                                type="hidden"
                                            />
                                            <input
                                                :value="current_report.name"
                                                name="_reportName"
                                                type="hidden"
                                            />

                                            <input
                                                :key="key"
                                                :name="key"
                                                :value="val"
                                                type="hidden"
                                                v-for="(
                                                    val, key
                                                ) in params_values"
                                            />
                                            <!-- TODO Handle multi-value -->

                                            <div class="row">
                                                <div
                                                    class="col-lg-3 col-4 col-form-label"
                                                >
                                                    &nbsp;
                                                </div>
                                                <div class="col-8">
                                                    <b-button
                                                        @click="postDownload()"
                                                        variant="primary full-width"
                                                        >Download
                                                        Report</b-button
                                                    >
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment";
import _ from "lodash";

import MenuRightOutlineIcon from "vue-material-design-icons/MenuRightOutline";
import ODateTime from "../components/forms/fields/ODateTime";

import { BFormGroup } from "bootstrap-vue";

export default {
    components: {
        ODateTime,
        MenuRightOutlineIcon,
        BFormGroup,
    },
    data() {
        return {
            formats: [
                { value: "pdf", text: "Acrobat PDF (.pdf)", icon: "file-pdf" },
                { value: "xls", text: "Excel 2003 (.xls)", icon: "file-excel" },
                { value: "doc", text: "Word (.doc)", icon: "file-word" },
            ],
            params_values: {},

            formState: { debug: false }, // Empty objects so the components are happy but they wont have anything
            se: {},
            date_field_config: {
                altFormat: "d/n/Y",
            },
        };
    },
    methods: {
        ...mapActions("ReportsModule", [
            "getAll",
            "getReportParams",
            "run_report",
        ]),
        download(format) {
            this.$set(this.params_values, "_format", format);

            var vm = this;

            setTimeout(() => {
                vm.postDownload();
            }, 10);
        },
        toggleDebug() {
            this.formState.debug = !this.formState.debug;
        },
        postDownload() {
            this.$refs.downloadForm.submit();
        },
        is_active(report) {
            if (!this.current_report) {
                return false;
            }

            return report.name == this.current_report.name;
        },
    },
    computed: {
        ...mapGetters("ReportsModule", {
            reports: "items",
            current_report: "item",
            downloadURL: "downloadURL",
            working: "working",
        }),
        _filename() {
            var title = this.$route.params.reportName;

            if (this.current_report && this.current_report.props) {
                title = this.current_report.props.title;
            }

            return (
                title +
                "_" +
                moment().format("YYYY-MM-DD") +
                "." +
                this.params_values._format
            );
        },
        reports_list() {
            //TODO check for superuser
            return _.filter(this.reports, function (r) {
                return !r.name.startsWith("_");
            });
        },
    },
    created() {
        this.getAll();

        if (this.$route.params.reportName) {
            var vm = this;

            if (
                this.$route.params.reportName &&
                this.$route.params.reportName != "NONE"
            ) {
                this.getReportParams(this.$route.params.reportName).then(
                    function (rpt) {
                        if (rpt.props.ext) {
                            this.form = rpt.props.ext;
                        }
                        vm.params_values = { _format: "pdf" };

                        if (rpt.props.ext) {
                            vm.params_values._format = rpt.props.ext;
                        }

                        // Set defaults and Hidden values
                        _.each(rpt.params, function (param) {
                            vm.$set(
                                vm.params_values,
                                param.name,
                                param.defaultVal
                            );
                        });
                    }
                );
            }
        }
    },
};
</script>
